module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product2-e2e138da946b545b3e51696711567096.jpg";